Namespace 'Common'

class Common.DropDownArrow extends Backbone.View
  template: JST['backbone/templates/common/drop_down_arrow']

  initialize: ->
    @currentArrowDirection = 'point_down_arrow'

  toggleArrow: ->
    if @currentArrowDirection == 'point_down_arrow'
      @currentArrowDirection = 'point_up_arrow'
    else
      @currentArrowDirection = 'point_down_arrow'
    @


  render: ->
    @$el.html(@template({
      image: window.image_path("arrows/#{@currentArrowDirection}.svg")
    }))
    @
